module.exports = __webpack_public_path__ + "static/media/snooze-status.9ef7fa7e.svg";